//转换属性值
//值的格式是：min-max:step，例如1-10:1，还有转换的比率conversion，常见于转换带宽
// import _isArray from 'lodash.isArray';

import convertRangeFloat from './convertRangeFloat';
export default function (_ref) {
  var _ref$values = _ref.values,
      values = _ref$values === undefined ? [] : _ref$values,
      _ref$propertyUnit = _ref.propertyUnit,
      propertyUnit = _ref$propertyUnit === undefined ? { code: '', name: '' } : _ref$propertyUnit,
      _ref$conversion = _ref.conversion,
      conversion = _ref$conversion === undefined ? 1 : _ref$conversion;

  var ret = values.map(function (v) {
    var valueType = v.valueType,
        _v$unit = v.unit,
        unit = _v$unit === undefined ? {} : _v$unit;

    var unitName = unit.code || propertyUnit.name || propertyUnit.code;
    if (valueType === 'range_float') {
      return convertRangeFloat(v, unitName, conversion);
    } else {
      return v;
    }
  });
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/convertRestriction/convertValue.js
// module id = 78
// module chunks = 0